var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescription({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1765864978412,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 956,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M792.064 56.896c68.48 0 124.48 54.08 124.48 120.128v669.952c0 66.048-56 120.128-124.48 120.128-21.76 0-40.448-6.016-59.136-15.04L512 837.952l-220.992 114.112c-59.072 30.08-136.896 9.024-168-48-9.344-18.048-15.552-36.096-15.552-57.152V177.088c0-66.112 56-120.192 124.48-120.192h560.128z m0 57.088H231.936c-34.24 0-62.208 27.008-62.208 60.096v669.824c0 9.088 3.072 21.12 6.208 27.072 15.552 30.08 52.864 39.04 83.968 24L512 768.896l252.096 129.216c9.28 5.952 18.624 5.952 27.968 5.952 34.24 0 62.208-27.008 62.208-60.096V174.08c0-33.088-27.968-60.16-62.208-60.16zM661.376 507.52c18.688 0 31.104 12.032 31.104 27.008v9.024c0 15.04-15.552 27.008-31.104 27.008H365.76c-18.688 0-31.168-11.968-31.168-27.008v-8.96c0-15.04 15.616-27.072 31.168-27.072h295.616z m0-177.28c18.688 0 31.104 12.032 31.104 27.072v8.96c0 15.04-15.552 27.072-31.104 27.072H365.76c-18.688 0-31.168-12.032-31.168-27.008v-9.088c0-14.976 15.616-27.008 31.168-27.008h295.616z",
    fill: "#a1a0a2",
    "p-id": 957
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.93f5811f638dc2be459bbd5a12a72572.svg";
export { ForwardRef as ReactComponent };